import { render, staticRenderFns } from "./CustomFieldEditForm.vue?vue&type=template&id=215127a8&scoped=true"
import script from "./CustomFieldEditForm.vue?vue&type=script&lang=js"
export * from "./CustomFieldEditForm.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldEditForm.vue?vue&type=style&index=0&id=215127a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215127a8",
  null
  
)

export default component.exports